var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: props.fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6615 9.76954C40.4518 11.3502 39.8111 13.2723 38.2304 14.0626L18.3552 24L38.2304 33.9374C39.8111 34.7277 40.4518 36.6498 39.6615 38.2305C38.8711 39.8111 36.949 40.4518 35.3683 39.6615L9.76888 26.862C8.68479 26.32 8 25.212 8 24C8 22.788 8.68479 21.68 9.76888 21.138L35.3683 8.33852C36.949 7.54819 38.8711 8.18888 39.6615 9.76954Z",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24C21 28.9706 16.7467 33 11.5 33C6.25329 33 2 28.9706 2 24C2 19.0294 6.25329 15 11.5 15C16.7467 15 21 19.0294 21 24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 11.5C46 16.7467 41.7467 21 36.5 21C31.2533 21 27 16.7467 27 11.5C27 6.25329 31.2533 2 36.5 2C41.7467 2 46 6.25329 46 11.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36.5C46 41.7467 41.7467 46 36.5 46C31.2533 46 27 41.7467 27 36.5C27 31.2533 31.2533 27 36.5 27C41.7467 27 46 31.2533 46 36.5Z"
  })));
};
export default SvgShare;